(() => {
  const instances = new WeakMap();
  const clamp = (value) => Math.max(0, Math.min(1, value));
  const init = (root) => {
    if (!root || instances.has(root)) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const hero = root.querySelector('[data-gb-hero]');
    const origin = root.querySelector('[data-gb-parallax]');
    const scene = root.querySelector('.gb-spotlight-scene');
    const story = root.querySelector('[data-gb-label-story]');
    const closing = root.querySelector('.gb-closing');
    let frame = 0;
    const render = () => {
      frame = 0;
      const vh = innerHeight;
      // Read every bounding box first, then write only composited transforms.
      const boxes = [hero, origin, scene, closing].map((el) => el?.getBoundingClientRect());
      const progress = (box) => reduced.matches ? .5 : clamp((vh - box.top) / (vh + box.height));
      const visible = (box) => box && box.bottom > -80 && box.top < vh + 80;
      if (hero && (visible(boxes[0]) || reduced.matches)) {
        hero.style.setProperty('--gb-hero-y', `${reduced.matches ? 0 : Math.min(Math.max(-boxes[0].top, 0) * .16, 150)}px`);
      }
      if (origin && (visible(boxes[1]) || reduced.matches)) {
        origin.style.setProperty('--gb-origin-progress', progress(boxes[1]).toFixed(4));
      }
      if (story && scene && (visible(boxes[2]) || reduced.matches)) {
        story.style.setProperty('--gb-label-progress', progress(boxes[2]).toFixed(4));
      }
      if (closing && (visible(boxes[3]) || reduced.matches)) {
        closing.style.setProperty('--gb-close-y', `${reduced.matches ? 0 : -11 + progress(boxes[3]) * 11}%`);
      }
    };
    const requestRender = () => { if (!frame) frame = requestAnimationFrame(render); };
    const options = { passive: true, signal: controller.signal };
    // No wheel/touch interception, scroll locking, animation loop, or pinning.
    addEventListener('scroll', requestRender, options);
    addEventListener('resize', requestRender, options);
    reduced.addEventListener('change', requestRender, { signal: controller.signal });
    root.querySelectorAll('.gb-reveal').forEach((item) => item.classList.add('is-visible'));
    instances.set(root, () => { controller.abort(); cancelAnimationFrame(frame); instances.delete(root); });
    render();
  };
  document.querySelectorAll('[data-ganbaru-home]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-ganbaru-home]')));
  document.addEventListener('shopify:section:unload', (event) => instances.get(event.target.querySelector('[data-ganbaru-home]'))?.());
})();
